import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

const SNS_TYPE = {
  INSTAGRAM: '인스타그램',
  TIKTOK: '틱톡',
  YOUTUBE: '유튜브',
  ETC: '기타',
}

export default function UserEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', '')
  const { data } = useApi({
    id: 'profileDetail',
    fn: api().adminUser.adminUserDetail,
    params: Number(id),
    enabled: !!id,
  })

  const { data: categoryList } = useApi({
    id: 'categoryList',
    fn: api().adminCategory.adminCategoryList,
  })

  const onSave = async (data: any) => {
    if (id) {
      const updateData: any = {
        role: data.role as unknown,
        status: data.status as unknown,
        email: data.email || '',
        password: data.password || '',
        withdrawReason: data.withdrawReason || '',
      }

      await api().adminUser.adminUserUpdate(Number(id), updateData)
    }
  }

  const wrap = {
    ...data,
    userData: {
      ...data?.userData,
      birthDate: dayjs(
        `${data?.userData.birthYear}-${data?.userData.birthMonth}-${data?.userData.birthDay}`,
      ).format('YYYY-MM-DD'),
    },
  }

  return (
    <ContentDetailView title="프로필 수정" data={wrap} onSave={onSave}>
      <DetailForm
        data={wrap}
        fields={[
          {
            label: '계정(이메일)',
            key: 'userData.email',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: 'sns',
            key: 'sns',
            type: FormFieldType.CUSTOM_READ_ONLY,
            readOnly: true,
            render: (data) => {
              return (
                <div className="flex flex-col gap-1">
                  {data?.userData.sns?.map((sns) => (
                    <div key={sns.id}>
                      {`${SNS_TYPE[sns.type as keyof typeof SNS_TYPE]}: ${sns.value}`}
                    </div>
                  ))}
                </div>
              )
            },
          },
          {
            label: '상태',
            key: 'status',
            type: FormFieldType.SELECT,
            options: [
              { label: '가입대기', value: 'PENDING' },
              { label: '활동', value: 'ACTIVE' },
              { label: '일시정지', value: 'SUSPENDED' },
              { label: '탈퇴', value: 'WITHDRAWN' },
            ],
            required: true,
            readOnly: data?.status === 'WITHDRAWN',
          },
          {
            label: '이름',
            key: 'userData.name',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '닉네임',
            key: 'userData.nickname',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '국적',
            key: 'userData.nation',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '전화번호',
            key: 'userData.phoneNumber',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '생년월일',
            key: 'userData.birthDate',
            type: FormFieldType.DATE,
            readOnly: true,
            default: dayjs(
              `${data?.userData.birthYear}-${data?.userData.birthMonth}-${data?.userData.birthDay}`,
            ).format('YYYY-MM-DD'),
          },
          {
            label: '관심분야',
            key: 'userData.interestCategories',
            type: FormFieldType.CHECKBOXGROUP,
            // required: false,
            readOnly: true,
            resolver(data) {
              return data?.userData.interestCategories?.map((item) => true)
            },
            options:
              categoryList?.items?.map((item) => ({
                id: item.id,
                label: item.name,
              })) ?? [],
          },
          {
            label: '약관동의일',
            key: 'userData.agreeTermsDate',
            type: FormFieldType.DATE,
            readOnly: true,
          },
          {
            label: '(필수)정보수집동의일',
            key: 'userData.agreeRequiredPrivacyInfoDate',
            type: FormFieldType.DATE,
            readOnly: true,
          },
          {
            label: '(선택)정보수집동의일',
            key: 'userData.agreeOptionalPrivacyInfoDate',
            type: FormFieldType.DATE,
            readOnly: true,
          },
          {
            label: '약관동의일',
            key: 'userData.agreeTermsDate',
            type: FormFieldType.DATE,
            readOnly: true,
          },
          {
            label: '마케팅동의일',
            key: 'userData.agreeMarketingInfoDate',
            type: FormFieldType.DATE,
            readOnly: true,
          },

          {
            label: '컨텍포인트',
            key: 'userData.contactPoints',
            type: FormFieldType.CUSTOM_READ_ONLY,
            readOnly: true,
            render: (data) => {
              return (
                <div className="flex flex-col gap-1">
                  {data?.userData.contactPoints?.map((contactPoint) => (
                    <div key={contactPoint.id}>
                      {`${contactPoint.type}: ${contactPoint.value}`}
                    </div>
                  ))}
                </div>
              )
            },
          },
        ]}
      />
    </ContentDetailView>
  )
}
